import { graphql, useStaticQuery } from 'gatsby';
import React, { FC, useContext } from 'react';

import { IMemberEstrogenGoalsPageContent } from '@ui/routes/MemberEstrogen/MemberEstrogenGoalsStep/MemberEstrogenGoalsStep.component';
import { MemberEstrogenGoalsStep } from '@ui/routes/MemberEstrogen/MemberEstrogenGoalsStep/index';

import { keysToCamel } from '@utils/butter';

import FlowContext from '@providers/FlowContextProvider';

import { IFlowStepProps } from '@folx-types/flow-steps';

export interface MemberEstrogenGoalsStepProps extends IFlowStepProps {}

const MemberEstrogenGoalsStepPage: FC<MemberEstrogenGoalsStepProps> = ({ path, stepKey }) => {
	const { existingFormData, handleFormSubmission, handleNavBack } = useContext(FlowContext);

	const { pageContent } = useStaticQuery<Record<string, string>>(graphql`
		{
			pageContent: butterPage(slug: { eq: "member-estrogen-hrt-goals" }) {
				page_header
				page_info
				hrt_goals_emotional_benefits
				hrt_goals_gender_euphoria
				hrt_goals_soften_face
				hrt_goals_improve_libido
				hrt_goals_increase_erectile_function
				hrt_goals_decrease_erectile_function
				hrt_goals_redistribute_fat
				hrt_goals_reduce_sweating
				hrt_goals_develop_breasts
				hrt_goals_body_hair
				hrt_goals_facial_hair
				hrt_goals_other
			}
		}
	`);

	const refinedContent: IMemberEstrogenGoalsPageContent = keysToCamel(
		pageContent
	) as IMemberEstrogenGoalsPageContent;

	return (
		<MemberEstrogenGoalsStep
			pageContent={refinedContent}
			path={path}
			stepKey={stepKey}
			existingFormData={existingFormData}
			handleFormSubmission={handleFormSubmission}
			handleNavBack={handleNavBack}
		/>
	);
};

export default MemberEstrogenGoalsStepPage;
